(function($){
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function( $block ) {
		//$block.find('img').doSomething();
	}

	function validateEmail(mail) {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
			return true;
		}
		return false;
	}
	
	// Initialize each block on page load (front end).
	$(document).ready(function(){
		$('.afpregisterform').each(function(){
			initializeBlock( $(this) );
		});
		
		$('form[name=afpregisterform]').on('submit', function(event){
			event.preventDefault();
			var $this = this;
			var fname = $($this).find('#fname').val();
			var lname = $($this).find('#lname').val();
			var email = $($this).find('#email').val();
			var username = $($this).find('#username').val();
			var password = $($this).find('#password').val();
			var paywall_price = $($this).find('#paywall_price').val();
			var payment_gateway = $($this).find('#payment_gateway').val();
			var cprofile_fields = $($this).find('#cprofile_fields').val();
			var custom_profile_fields = [];
			if( cprofile_fields !== '' ) {
				custom_profile_fields = cprofile_fields.split("|");
			}

			var message = '';
		
			if(fname == ''){
				message = 'Please enter your first name.';
				$($this).find('#fname').focus();
			}else if(lname == ''){
				message = 'Please enter your last name.';
				$($this).find('#lname').focus();
			}else if(email == ''){
				message = 'Please enter your email address.';
				$($this).find('#email').focus();
			}else if(!validateEmail(email)) {
				message = 'Please enter a valid email address.';
			}else if(username == ''){
				message = 'Please enter your username.';
				$($this).find('#username').focus();
			}else if(password == ''){
				message = 'Please enter your password.';
				$($this).find('#password').focus();
			}else if( custom_profile_fields.length > 0 ) {
				for( i = 0; i < custom_profile_fields.length; i++ ) {
					$value = $($this).find( '#' + custom_profile_fields[i] ).val();
					$required = $($this).find( '#' + custom_profile_fields[i] ).attr( 'data-required' );
					$type = $($this).find( '#' + custom_profile_fields[i] ).attr( 'data-type' );
					$placeholder = $($this).find( '#' + custom_profile_fields[i] ).attr( 'placeholder' );
		
					if($value == '' && $required == 'von' ) {
						message = 'Please enter the ' + $placeholder;
						$($this).find( '#' + custom_profile_fields[i] ).focus();
						break;
					}else if( isNaN( $value ) && $type == 'phone' ) {
						message = ' The ' + $placeholder + ' should have numeric value.';
						$($this).find( '#' + custom_profile_fields[i] ).focus();
						break;
					}
				}
			} else if(payment_gateway == 'auth'){
				if( typeof afp_auth.login_id !== 'undefined' && afp_auth.login_id !== "" && typeof afp_auth.client_key !== 'undefined' && afp_auth.client_key !== "" && typeof afp_auth.trans_key !== "undefined" && afp_auth.trans_key != "" ) {
					var cardNumber = $('input:text[name=cardNumber]').val();
					var expMonth = $('input:text[name=expMonth]').val();
					var expYear = $('input:text[name=expYear]').val();
					var cardCode = $('input:text[name=cardCode]').val();
					if(cardNumber == ''){
						message = 'Please provide a valid credit card number.';
						$($this).find('input:text[name=cardNumber]').focus();
					}else if(expYear == ''){
						message = 'Please provide valid expiration year.';
						$($this).find('input:text[name=expYear]').focus();
					}else if(expMonth == ''){
						message = 'Please provide valid expiration month.';
						$($this).find('input:text[name=expMonth]').focus();
					}else if(cardCode == ''){
						message = 'Please provide valid CVV.';
						$($this).find('input:text[name=cardCode]').focus();
					}
				}
			}
		
			if(message !== ''){
				$($this).find('.message').html( '<span class="afperror">'+message+'</span>');
			}else{
				if(paywall_price != '' && paywall_price != 0){
					if(payment_gateway == 'stripe'){
						if(typeof afp.stripe !== 'undefined' && afp.stripe !== ""){
							var additionalData = {
								name:fname +' '+lname,
							};
		
							var response = '';
							stripe.createToken(card, additionalData).then(function(response) {
								if(response.error) {
									// Inform the user if there was an error.
									var errorElement = $( '#card-errors' );
									errorElement.textContent = response.error.message;
									event.preventDefault();
								}else{
									var token = response.token;
									var token_id = token.id;
									$($this).find('input:hidden[name=token_id]').val(token_id);
									var form = document.getElementById('afpregisterform');
									form.submit();
								}
							});
						}else{
							var form = document.getElementById('afpregisterform');
							form.submit();
						}
					}else if(payment_gateway == 'auth'){
						if( typeof afp_auth.login_id !== 'undefined' && afp_auth.login_id !== "" && typeof afp_auth.client_key !== 'undefined' && afp_auth.client_key !== "" && typeof afp_auth.trans_key !== "undefined" && afp_auth.trans_key != "" ) {
							var authData = {};
							authData.clientKey = afp_auth.client_key;
							authData.apiLoginID = afp_auth.login_id;
		
							var cardData = {};
							cardData.cardNumber = cardNumber;
							cardData.month = expMonth;
							cardData.year = expYear;
							cardData.cardCode = cardCode;
		
							var secureData = {};
							secureData.authData = authData;
							secureData.cardData = cardData;
		
							Accept.dispatchData(secureData, responseHandler);
		
							function responseHandler(response) {
								if(response.messages.resultCode === "Error"){
									var i = 0;
									var error = '';
									var code = '';
									while (i < response.messages.message.length) {
										code = response.messages.message[i].code;
										error = response.messages.message[i].text;
										break;
									}
		
									if(error != ''){
										$($this).find('.message').html('<span class="afperror">'+error+'</span>');
										if(code == 'E_WC_05'){
											$($this).find('input:text[name=cardNumber]').focus();
										}else if(code == 'E_WC_06') {
											$($this).find('input:text[name=expMonth]').focus();
										}else if(code == 'E_WC_07'){
											$($this).find('input:text[name=expYear]').focus();
										}
									}
								} else {
									paymentFormUpdate(response.opaqueData);
								}
							}
		
							function paymentFormUpdate(opaqueData) {
								$("input:hidden[name=dataDescriptor]").val(opaqueData.dataDescriptor);
								$("input:hidden[name=dataValue]").val(opaqueData.dataValue);
		
								// If using your own form to collect the sensitive data from the customer,
								// blank out the fields before submitting them to your server.
								$("input:text[name=cardNumber]").val("");
								$("input:text[name=expMonth]").val("");
								$("input:text[name=expYear]").val("");
								$("input:text[name=cardCode]").val("");
		
								var form = document.getElementById('afpregisterform');
								form.submit();
							}
						}else{
							var form = document.getElementById('afpregisterform');
							form.submit();
						}
					}else{
						var form = document.getElementById('afpregisterform');
						form.submit();
					}
				}else{
					var form = document.getElementById('afpregisterform');
					form.submit();
				}
			}
		});
	});

	// Initialize dynamic block preview (editor).
	if( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=afpregister', initializeBlock );
	}

})(jQuery);